/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Noncustomer_TitleInputs */

const en_home_noncustomer_title = /** @type {(inputs: Home_Noncustomer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not a customer yet?`)
};

const fr_home_noncustomer_title = /** @type {(inputs: Home_Noncustomer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas encore client ?`)
};

/**
* | output |
* | --- |
* | "Not a customer yet?" |
*
* @param {Home_Noncustomer_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_noncustomer_title = /** @type {((inputs?: Home_Noncustomer_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Noncustomer_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_noncustomer_title(inputs)
	return fr_home_noncustomer_title(inputs)
});